import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const RecreationPage = lazy(() => import("../pages/recreation/page"));
const RealEstatePage = lazy(() => import("../pages/real-estate/page"));
const UtilitiesPage = lazy(() => import("../pages/utilities/page"));
const JobsPage = lazy(() => import("../pages/jobs/page"));
const EventsPage = lazy(() => import("../pages/events/page"));
const EventDetailPage = lazy(() => import("../pages/events/[id]/page"));
const FoodDrinkPage = lazy(() => import("../pages/food-drink/page"));
const FoodDrinkDetailPage = lazy(() => import("../pages/food-drink/[id]/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const BlogDetailPage = lazy(() => import("../pages/blog/[id]/page"));
const ProfilePage = lazy(() => import("../pages/profile/page"));
const AdvertisePage = lazy(() => import("../pages/advertise/page"));
const DealsPage = lazy(() => import("../pages/deals/page"));
const DealDetailPage = lazy(() => import("../pages/deals/[id]/page"));
const DirectoryPage = lazy(() => import("../pages/directory/page"));
const DirectoryDetailPage = lazy(() => import("../pages/directory/[id]/page"));
const TransportationPage = lazy(() => import("../pages/transportation/page"));
const RelocationPage = lazy(() => import("../pages/relocation/page"));
const NeighborhoodDetailPage = lazy(() => import("../pages/neighborhoods/[slug]/page"));
const SubscriptionsPage = lazy(() => import("../pages/subscriptions/page"));
const SubmitBusinessPage = lazy(() => import("../pages/submit-business/page"));
const OwnerDashboardPage = lazy(() => import("../pages/owner-dashboard/page"));
const FAQPage = lazy(() => import("../pages/faq/page"));
const CalendarPage = lazy(() => import("../pages/calendar/page"));
const GalleryPage = lazy(() => import("../pages/gallery/page"));
const EmergencyPage = lazy(() => import("../pages/emergency/page"));
const PreparednessPage = lazy(() => import("../pages/preparedness/page"));
const NewsPage = lazy(() => import("../pages/news/page"));
const NewsDetailPage = lazy(() => import("../pages/news/[id]/page"));
const NewsArchivePage = lazy(() => import("../pages/news/archive/page"));
const ParksPage = lazy(() => import("../pages/parks/page"));
const DataSourcesPage = lazy(() => import("../pages/data-sources/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const FavoritesPage = lazy(() => import("../pages/favorites/page"));
const PromoteEventPage = lazy(() => import("../pages/promote-event/page"));
const SubmitDealPage = lazy(() => import("../pages/submit-deal/page"));
const DealDashboardPage = lazy(() => import("../pages/deal-dashboard/page"));
const AdvertiseDisplayPage = lazy(() => import("../pages/advertise-display/page"));
const LeadsPage = lazy(() => import("../pages/leads/page"));
const LeadDashboardPage = lazy(() => import("../pages/lead-dashboard/page"));
const SubmitEventPage = lazy(() => import("../pages/submit-event/page"));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/events/:id',
    element: <EventDetailPage />,
  },
  {
    path: '/food-drink',
    element: <FoodDrinkPage />,
  },
  {
    path: '/food-drink/:id',
    element: <FoodDrinkDetailPage />,
  },
  {
    path: '/jobs',
    element: <JobsPage />,
  },
  {
    path: '/real-estate',
    element: <RealEstatePage />,
  },
  {
    path: '/recreation',
    element: <RecreationPage />,
  },
  {
    path: '/utilities',
    element: <UtilitiesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:id',
    element: <BlogDetailPage />,
  },
  {
    path: '/favorites',
    element: <FavoritesPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/advertise',
    element: <AdvertisePage />,
  },
  {
    path: '/advertise-display',
    element: <AdvertiseDisplayPage />,
  },
  {
    path: '/deals',
    element: <DealsPage />,
  },
  {
    path: '/deals/:id',
    element: <DealDetailPage />,
  },
  {
    path: '/directory',
    element: <DirectoryPage />,
  },
  {
    path: '/directory/:id',
    element: <DirectoryDetailPage />,
  },
  {
    path: '/transportation',
    element: <TransportationPage />,
  },
  {
    path: '/relocation',
    element: <RelocationPage />,
  },
  {
    path: '/relocation-partners',
    lazy: async () => {
      const { default: RelocationPartnersPage } = await import('../pages/relocation-partners/page');
      return { Component: RelocationPartnersPage };
    }
  },
  {
    path: '/neighborhoods/:slug',
    element: <NeighborhoodDetailPage />,
  },
  {
    path: '/subscriptions',
    element: <SubscriptionsPage />,
  },
  {
    path: '/submit-business',
    element: <SubmitBusinessPage />,
  },
  {
    path: '/owner-dashboard',
    element: <OwnerDashboardPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/calendar',
    element: <CalendarPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/emergency',
    element: <EmergencyPage />,
  },
  {
    path: '/preparedness',
    element: <PreparednessPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/archive',
    element: <NewsArchivePage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/parks',
    element: <ParksPage />,
  },
  {
    path: '/data-sources',
    element: <DataSourcesPage />,
  },
  {
    path: '/weather',
    element: <></>,
    lazy: async () => {
      const { default: Component } = await import('../pages/weather/page');
      return { Component };
    }
  },
  {
    path: '/schools',
    element: <></>,
    lazy: async () => {
      const { default: Component } = await import('../pages/schools/page');
      return { Component };
    }
  },
  {
    path: '/promote-event',
    element: <PromoteEventPage />
  },
  {
    path: '/submit-deal',
    element: <SubmitDealPage />
  },
  {
    path: '/deal-dashboard',
    element: <DealDashboardPage />
  },
  {
    path: '/leads',
    element: <LeadsPage />
  },
  {
    path: '/lead-dashboard',
    element: <LeadDashboardPage />
  },
  {
    path: '/submit-event',
    element: <SubmitEventPage />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;